export default "__VITE_ASSET__DKI2L5uG__"